import { Instance } from "mobx-state-tree";
import React from "react";
import { RankingResponseV1Model } from "../../models/RespondentSubmittedResponseModels/RankingResponseV1Model";
import { Stack, Typography } from "@mui/material";
import { S1TypographyLabel } from "./S1TypographyLabel";
import { TFunction } from "i18next";
import {
  FoundationColorTokens,
  Typography as LeoTypography,
  Spacing,
} from "@surya-digital/leo-reactjs-material-ui";
import { B1TypographyLabel } from "./B1TypographyLabel";
import { observer } from "mobx-react";

interface RankingResponseProps {
  question: string | null;
  rankingResponse: Instance<typeof RankingResponseV1Model>;
  t: TFunction;
  tokens: FoundationColorTokens<string>;
  typography: LeoTypography;
  spacing: Spacing;
}

export const RankingResponse = observer(
  ({
    question,
    rankingResponse,
    t,
    tokens,
    typography,
    spacing,
  }: RankingResponseProps): React.ReactElement => {
    const formattedResponse = rankingResponse.rankingResponse
      .split(",")
      .join(",\n");
    return (
      <Stack>
        {question && (
          <S1TypographyLabel
            text={t("projects.respondentResponseDialog.questionPrefix", {
              question,
            })}
            tokens={tokens}
            typography={typography}
          />
        )}
        <Stack direction="row" gap={spacing.spaceXXS}>
          <B1TypographyLabel
            text={t("projects.respondentResponseDialog.answerPrefix", {
              response: "",
            })}
            tokens={tokens}
            typography={typography}
          />
          <Typography
            {...typography.b1}
            color={tokens.label}
            style={{ whiteSpace: "pre-line" }}
          >
            {formattedResponse}
          </Typography>
        </Stack>
      </Stack>
    );
  },
);
